import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import Stack from "../../components/ui/Stack";
import Form from "../../components/common/form/Form";
import {vendorLoginFormModel} from "../../models/vendorLoginModel";
import {vendorLoginSchema} from "../../schema/vendorLoginSchema";
import {vendorLogin, fetchVendorToken} from "../../store/vendor-slice";
import {useNavigate, useParams} from "react-router-dom";

//Todo: Vendor login and authentication is pending
const VendorLogin = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const params = useParams();
    const {isValid, vendorLoginStatus, loginError} = useSelector(state => state.vendor);
    const path = `/vendor-dashboard/${params.vendorId}/${params.scopeId}`;

    const formSubmitHandler = (data) => {
        const updatedData = {
            ...data,
            id: params.scopeId,
            vendor: params.vendorId,
        }
        dispatch(vendorLogin(updatedData));
    }

    useEffect(() => {
        dispatch(fetchVendorToken())
    }, [dispatch])

    useEffect(() => {
        if (isValid) {
            navigate(`${path}/docUpload`);
        }
    }, [isValid, navigate, path]);

    const initialData = vendorLoginFormModel();
    const schema = vendorLoginSchema();

    return (
        <div className="container-fluid p-0 vh-100">
            <div className="row h-100 g-0">
                <div className="col">
                    <Stack className="align-items-center justify-content-center h-100">
                        <div className="card mb-7 bg-white border-0 rounded-4">
                            <div className="card-body p-6" style={{width: "400px"}}>
                                <h4 className="text-center fw-semibold mb-3">Welcome back!</h4>
                                <p className="fs-md opacity-50 fw-medium mb-4 text-center">Sign in to continue</p>
                                <Form onFormSubmit={formSubmitHandler}
                                      schema={schema}
                                      initialData={initialData}
                                      status={vendorLoginStatus}
                                      error={loginError}
                                />
                            </div>
                        </div>
                    </Stack>
                </div>
            </div>
        </div>
    )
};
export default VendorLogin;
